<template>
  <div id="buyer_info_sector" class="sector buyer-sector">
    <div class="row">
      <div class="col-12 sector__header text-accent">
        {{ $t("carts.buyerInfo") }}
      </div>
      <div class="col-12 sector__content">
        <div class="row">
          <div class="col-12 col-md-3 py-0">
            <el-form-item :label="$t('users.name')" prop="buyer_name">
              <!-- <el-input v-model="form.buyer_name" :placeholder="$t('carts.required')" size="large" maxlength="50" /> -->
              <el-input-sanitize v-model="form.buyer_name" :placeholder="$t('carts.required')" size="large" maxlength="50"
                @blur="updateToName" />
            </el-form-item>
          </div>
          <div class="col-12 col-md-4 py-0">
            <el-form-item :label="$t('users.phone')" prop="buyer_mobile" class="el-form-item-buyer-mobile">
              <el-input-mobile v-model="form.buyer_mobile" :country="form.country" :placeholder="$t('carts.required')"
                size="large" @input="(value) => form.buyer_mobile = value" @blur="updateToMobile" />
            </el-form-item>
            <p v-if="isMobile" class="text-accent text-sm sm:text-xs my-1 mx-0" :style="{
              lineHeight: '20px',
            }">
              為了方便您查詢訂單，<br />
              訂購人手機號碼與登入會員之號碼需一致。
            </p>
          </div>
          <div class="col-12 col-md-5 py-0">
            <el-form-item :label="$t('users.email')" prop="buyer_email">
              <el-input v-model="form.buyer_email" :placeholder="$t('carts.optional')" size="large" maxlength="50" />
            </el-form-item>
          </div>
        </div>
        <div v-if="!isMobile" class="row">
          <div class="col-md-9 offset-md-3 pa-0">
            <p class="text-accent text-sm sm:text-xs my-1 mx-0 px-3" :style="{
              lineHeight: '20px',
            }">
              為了方便您查詢訂單，訂購人手機號碼與登入會員之號碼需一致
            </p>
          </div>
        </div>
      </div>
      <el-form-item prop="buyer-info"></el-form-item>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from "vue";
import { useVModel } from "@vueuse/core";
import { breakpoint } from "../../../utils"
import ElInputSanitize from "./InputComponents/ElInputSanitize.vue";
import ElInputMobile from "./InputComponents/ElInputMobile.vue";

const props = defineProps({
  modelValue: Object,
});
const emit = defineEmits(["update:modelValue"]);
const form = useVModel(props, "modelValue", emit);

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm);


const updateToName = () => {
  const newBuyerName = form.value.buyer_name;
  if (newBuyerName) {
    if (!form.value.to_name || newBuyerName.startsWith(form.value.to_name)) {
      form.value.to_name = newBuyerName;
    }
  }
};

const updateToMobile = () => {
  const newBuyerMobile = form.value.buyer_mobile;
  if (newBuyerMobile) {
    if (!form.value.to_mobile || newBuyerMobile.startsWith(form.value.to_mobile)) {
      form.value.to_mobile = newBuyerMobile;
    }
  }
};

// watch(
//   () => form.value.buyer_name,
//   (newBuyerName) => {
//     if (newBuyerName) {
//       if (!form.value.to_name || newBuyerName.startsWith(form.value.to_name)) {
//         form.value.to_name = newBuyerName;
//       }
//     }
//   }
// );

// watch(
//   () => form.value.buyer_mobile,
//   (newBuyerMobile) => {
//     if (newBuyerMobile) {
//       if (!form.value.to_mobile || newBuyerMobile.startsWith(form.value.to_mobile)) {
//         form.value.to_mobile = newBuyerMobile;
//       }
//     }
//   }
// );

</script>

<style lang="scss">
.buyer-sector {
  .sector__content {
    padding: 15px 15px;

    .el-form-item {
      margin-bottom: 6px;

      label {
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>